var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"jumbotron-theme py-4 shadow-sm"},[_c('h1',{staticClass:"h3 font-weight-light mt-0"},[_vm._v("\n            Olá "+_vm._s(_vm.name)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"lead m-0"},[_vm._v("\n            "+_vm._s(_vm.dateNow)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }